<template>
  <div class="password__container">
    <input
      :placeholder="placeholder"
      :type="type"
      :value="value"
      :autocomplete="newPassword ? 'new-password' : 'current-password'"
      class="password"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @input="
        event => {
          $emit('changedValue', event.target.value);
        }
      "
    />
    <div
      class="password__toggle -tooltip-"
      :class="{ 'password__toggle--active': isShow }"
      @click="isShow = !isShow"
    >
      <PasswordIcon />
    </div>
  </div>
</template>
<script>
import PasswordIcon from '@/components/Icons/PasswordIcon.vue';

export default {
  name: 'PasswordInput',
  components: {
    PasswordIcon
  },
  props: {
    placeholder: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    newPassword: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShow: false
    };
  },
  computed: {
    type() {
      return this.isShow ? 'text' : 'password';
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

input::placeholder {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.3px;
  color: #76767b;
}

input {
  padding: 16px 13px 14px;
  width: 100%;
  border: none;
  background: transparent;
}

input::-webkit-credentials-auto-fill-button {
  position: absolute;
  right: 40px;
}

.password {
  @include uiFont;
  @extend %text-400-14;

  &__container {
    position: relative;
  }

  &__toggle {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    cursor: pointer;

    &--active::v-deep svg path {
      fill: #6979f8;
    }
  }

  &__info {
    width: 16px;
    height: 16px;
    background-color: black;
  }
}
</style>
